import React from 'react';
import { Modal, Button, Row, Col, ButtonGroup, Table } from 'react-bootstrap';
import Chart from './Chart';
import TickerNews from './TickerNews';
import { 
  priceColor, 
  formatPercent, 
  numFormat, 
  format,
  formatDateYYYYMMDD
} from '../../containers/Dashboard/Helpers';
import './TickerModal.css';

const TickerModal = ({ 
  showTickerModal, 
  closeModal, 
  currentTickerInfo: item, 
  getChartInfo, 
  chartInfo, 
  tickerNewsInfo 
}) => {

  if (item.length < 1) return null;

  return (
    <Modal show={showTickerModal} onHide={() => closeModal('showTickerModal')} id="ticker-info-modal" bsSize="large">
      <Modal.Header closeButton>
        <Modal.Title>{ item.name } ({ item.symbol }) 
          <span 
            className={priceColor(item.percentChange)}
            style={{ fontSize: 16, paddingLeft: 8 }}>
            {item.price} ({formatPercent(item.percentChange)})
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={5}>
            <Col md={12}>
              <Table className="ticker-stats">
                <tbody>
                  <tr>
                    <td>Previous Close</td>
                    <td>{item.previousClose}</td>
                  </tr>
                  <tr>
                    <td>Open</td>
                    <td>{item.open}</td>
                  </tr>
                  <tr>
                    <td>52 Week Range</td>
                    <td>{item.yearRange}</td>
                  </tr>
                  <tr>
                    <td>Earnings</td>
                    <td>{formatDateYYYYMMDD(item.earningsDate)}</td>
                  </tr>
                  <tr>
                    <td>Market Cap.</td>
                    <td>{numFormat(item.marketCap)}</td>
                  </tr>
                  <tr>
                    <td>Beta</td>
                    <td>{format(item.beta)}</td>
                  </tr>
                  <tr>
                    <td>PE Ratio</td>
                    <td>{format(item.PERatio)}</td>
                  </tr>
                  <tr>
                    <td>EPS</td>
                    <td>{format(item.EPS)}</td>
                  </tr>
                  <tr>
                    <td>Dividend</td>
                    <td>{format(item.dividend)} ({formatPercent(item.dividendPercent)})</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Col>
          <Col md={7}>
            <ButtonGroup className="chart-btn-group">
              <Button onClick={() => getChartInfo({ symbol: item.symbol, range: '1d' })}>1D</Button>
              <Button onClick={() => getChartInfo({ symbol: item.symbol, range: '5d' })}>5D</Button>
              <Button onClick={() => getChartInfo({ symbol: item.symbol, range: '1m' })}>1M</Button>
              <Button onClick={() => getChartInfo({ symbol: item.symbol, range: '6m' })}>6M</Button>
              <Button onClick={() => getChartInfo({ symbol: item.symbol, range: 'ytd' })}>YTD</Button>
              <Button onClick={() => getChartInfo({ symbol: item.symbol, range: '1y' })}>1Y</Button>
              <Button onClick={() => getChartInfo({ symbol: item.symbol, range: '5y' })}>5Y</Button>
              <Button onClick={() => getChartInfo({ symbol: item.symbol, range: 'max' })}>Max</Button>
            </ButtonGroup>
            <Chart 
              chartInfo={chartInfo} 
              symbol={item.symbol} 
              price={item.percentChange} />
          </Col>
        </Row>
        <TickerNews tickerNewsInfo={tickerNewsInfo} />
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-primary" onClick={() => closeModal('showTickerModal')}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TickerModal;
